export const TEXT = {
  SIZE: {
    SMALL: 16,
    MEDIUM: 24,
    LARGE: 32,
    SECTION: 50,
  },
  DEFAULTCOLOR: '#000',
} as const;

export const CHANNEL = {
  WEB: 'web',
  POS: 'pos',
  REPORTING: 'reporting',
} as const;

export const CATEGORY_TYPES = {
  SEATED: 'seated',
  GA: 'ga',
} as const;

export const MODE = {
  LAYOUTCHOOSER: 'layoutchooser',
  INITIAL: 'initial',
  DRAWING: 'drawing',
  LABELS: 'labels',
  CATEGORIES: 'seats',
  POS: 'pos',
  BLOCKSEATS: 'blockseats',
  GROUP: 'group',
  RENDERER: 'renderer',
} as const;

export const DRAWINGMODE = {
  MAIN: 'drawing:main',
  ROWS: 'drawing:rows',
  TEXT: 'drawing:texts',
  SECTION: {
    MAIN: 'drawing:sections',
    ROUNDED: 'drawing:sections:circle',
    RECTANGULAR: 'drawing:sections:rect',
    POLYGONAL: 'drawing:sections:polygon',
    PATH: 'drawing:sections:path',
  },
  GA: {
    MAIN: 'drawing:ga',
    ROUNDED: 'drawing:ga:circle',
    RECTANGULAR: 'drawing:ga:rect',
    POLYGONAL: 'drawing:ga:polygon',
  },
  SHAPES: {
    MAIN: 'drawing:shapes',
    SIMPLE: {
      MAIN: 'drawing:shapes:simple',
      LINE: 'drawing:shapes:simple:line',
      CIRCLE: 'drawing:shapes:simple:circle',
      RECT: 'drawing:shapes:simple:rect',
      POLYGON: 'drawing:shapes:simple:polygon',
    },
    PREDEFINED: {
      FOOD: 'drawing:shapes:predefined:food',
      BAR: 'drawing:shapes:predefined:bar',
      EXIT: 'drawing:shapes:predefined:exit',
      BATHROOM: 'drawing:shapes:predefined:bathroom',
      STAGE: 'drawing:shapes:predefined:stage',
      ACCESSIBLE: 'drawing:shapes:predefined:accessible',
    },
  },
  TABLE: {
    MAIN: 'drawing:tables',
    ROUNDED: 'drawing:tables:rounded',
    RECTANGULAR: 'drawing:tables:rectangular',
  },
  BGIMAGE: 'drawing:bgimage',
  STAGEPIN: 'drawing:stagepin',
} as const;

export const LAYOUT = {
  NOTSELECTED: 'notselected',
  ROWS: 'rows',
  ZONES: 'zones',
  TABLES: 'tables',
  MIXED: 'mixed',
  INSIDEZONE: 'insidezone',
  SECTIONS: 'sections',
  INSIDESECTION: 'insidesection',
} as const;

export const SEATSTATUS = {
  FREE: 0,
  OCCUPIED: 1,
  RESERVED: 2,
  CART: 3,
  LOCKED: 4,
  SELECTED: 5,
  DISABLED: 6,
} as const;

export const TYPE = {
  SEAT: 'seat',
  ROW: 'row',
  BLOCK: 'block',
  SECTION: 'section',
  SECTION_POLYGONAL: 'section_polygonal',
  SECTION_ROUNDED: 'section_rounded',
  SECTION_RECTANGULAR: 'section_rectangular',
  TEXT: 'text',
  TABLE: 'table',
  TABLE_ROUNDED: 'table_rounded',
  TABLE_RECTANGULAR: 'table_rectangular',
  TABLESEAT: 'table_seat',
  GA: 'ga',
  GA_POLYGONAL: 'ga_polygonal',
  GA_ROUNDED: 'ga_rounded',
  GA_RECTANGULAR: 'ga_rectangular',
  // UNIT: 'unit',
  SHAPE: 'shape',
  CIRCLE: 'circle',
  ELLIPSE: 'ellipse',
  LINE: 'line',
  RECT: 'rect',
  POLYGON: 'polygon',
  PATH: 'path',
  PREDEFINED: 'predefined',
} as const;

export const TABLE = {
  RECTANGULAR: {
    TYPE: 1,
    SEATSCOUNT: 8,
    WIDTH: 120,
    HEIGHT: 36,
    AUTO_WIDTH_COEF: 30,
    DIRECTION: {
      ONESIDE: 1,
      TWOSIDES: 2,
      FOURSIDES: 4,
    },
    SIDE: {
      TOP: 1,
      RIGHT: 2,
      BOTTOM: 3,
      LEFT: 4,
    },
  },
  ROUNDED: {
    TYPE: 2,
    RADIUS: 24,
    SEATSCOUNT: 6,
    AUTO_RADIUS_COEF: 4,
  },
} as const;

export const SEAT = {
  LABEL: '?',
  INNER_RADIUS: 20,
  GAP: 5,
} as const;

export const GA = {
  LABEL: {
    text: 'GA',
    size: 20,
    fill: 'rgb(80, 78, 78)',
    rotation: 0,
    vOffset: 0,
    hOffset: 0,
  },
  CAPACITY: 100,
} as const;

export const SECTION = {
  DEFAULTFILLCOLOR: 'rgba(255,255,255,1)',
  DEFAULTSTROKECOLOR: 'rgba(0,0,0,1)',
  TRANSPARENTFILLCOLOR: 'rgba(0,0,0,0)',
  TRANSPARENTSTROKECOLOR: 'rgba(0,0,0,0)',
  CONFLICTSTROKECOLOR: 'rgba(255,0,0,1)',
  CATEGORYZONESTROKE: '#ed5565',
  CATEGORYZONESMARKINGDURATIONINMS: '3000',
  DEFAULT_SEAT_SPACING: 5,
  DEFAULT_ROW_SPACING: 10,
} as const;

export const SECTIONSTATUS = {
  AVAILABLE: 0,
  SOLD: 1,
  UNAVAILABLE: 2,
} as const;

export const FULLSEATGAP = SEAT.INNER_RADIUS + SEAT.GAP;

export const SEATRADIUS = SEAT.INNER_RADIUS / 2;

export const GRIDSNAP = 25;

export const PAN = {
  UP: 1,
  RIGHT: 2,
  DOWN: 3,
  LEFT: 4,
  CENTER: 5,
} as const;

export const ZOOM = {
  IN: 1,
  OUT: 2,
  SCALEFACTOR: 0.8,
  SCALEWHEELFACTOR: 0.8,
  ZOOMFACTOR: 0.02,
  ZOOMFACTORMOBILE: 0.1,
  MIN: 0.1,
  MINFORMOBILE: 1,
  MAX: 60,
  MAXFORMOBILE: 10,
  LEVELS: {
    SECTION: 7,
    DEFAULT: 3,
    DEFAULTDESIGNER: 1,
    INSIDESECTION: 0,
    MOBILEINSIDESECTION: 8,
  },
  MODES: {
    DEFAULT: 0,
    SMOOTH: 1,
    SCROLL: 2,
  },
  DURATIONS: {
    DEFAULT: 10,
    FAST: 5,
    SLOW: 500,
  },
  STEP: 7,
} as const;

export const BG_START_SCALE_RATE = 0.5;
export const OPACITY_START_SCALE_RATE = 0;

export const DOUBLE_PI = 2 * Math.PI;

export const FLIP = {
  HORIZONTALLY: 'y',
  VERTICALLY: 'x',
} as const;

export const LABEL_TYPES = {
  NUMERICAL: 'numerical',
  LITERAL: 'literal',
  DOUBLELITERAL: 'doubleliteral',
  ODD: 'odd',
  EVEN: 'even',
  ODD_EVEN: 'odd_even',
  EVEN_ODD: 'even_odd',
} as const;

export const EVENTSTATUS = {
  DRAFT: 0,
  PUBLISHED: 1,
  PAUSED: 2,
} as const;

export const LOCK = {
  SHAPE:
    'M321.8,455.5h356.4V321.8c0-49.2-17.4-91.2-52.2-126c-34.8-34.8-76.8-52.2-126-52.2c-49.2,0-91.2,17.4-126,52.2c-34.8,34.8-52.2,76.8-52.2,126L321.8,455.5L321.8,455.5z M900.9,522.3v400.9c0,18.6-6.5,34.3-19.5,47.3c-13,13-28.8,19.5-47.3,19.5H165.9c-18.6,0-34.3-6.5-47.3-19.5c-13-13-19.5-28.8-19.5-47.3V522.3c0-18.6,6.5-34.3,19.5-47.3c13-13,28.8-19.5,47.3-19.5h22.3V321.8c0-85.4,30.6-158.7,91.9-219.9C341.3,40.7,414.7,10,500,10c85.3,0,158.7,30.6,219.9,91.9c61.3,61.3,91.9,134.6,91.9,219.9v133.6h22.3c18.6,0,34.3,6.5,47.3,19.5C894.4,488,900.9,503.7,900.9,522.3L900.9,522.3z',
  FILL: '#404040',
} as const;
export const DISABLED = {
  SHAPE:
    'M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z',
  FILL: '#000000',
} as const;
export const CHECKMARK = {
  SHAPE: 'M4.5 12.75l6 6 9-13.5',
  STROKE: '#000000',
} as const;

export const RESERVED = {
  SHAPE:
    'M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Zm0,9.42857A3.42857,3.42857,0,1,1,11.42857,8,3.42857,3.42857,0,0,1,8,11.42857Z',
  STROKE: '#000000',
} as const;

export const CART = {
  SHAPE: 'M4.5 12.75l6 6 9-13.5',
  STROKE: '#FFFFFF',
} as const;

export const OCCUPIED = {
  SHAPE: 'M-1,1 l2,-2 M0,5 l5,-5 M4,6 l2,-2',
  STROKE: '#000000',
} as const;

export const OBSTRUCTED = {
  SHAPE: 'M 0 50 L 50 0 A 15 15 0 0 1 0 50 Z',
};

export const RENDERER_MODE = import.meta.env.VITE_APP_RENDERER === 'true';
